import { render, staticRenderFns } from "./JobProgressBar.vue?vue&type=template&id=af9c059a&scoped=true"
import script from "./JobProgressBar.vue?vue&type=script&lang=js"
export * from "./JobProgressBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af9c059a",
  null
  
)

export default component.exports